import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import { setActivePage, setComparedEntity } from '../../actions/ui';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import styles from './compare-select-entities.module.scss';
import Button from '../../components/button';
import classNames from 'classnames';
import { groupByKey } from '../../helpers/group-by-key';

class CompareSelectEntitiesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEntity: null,
    };
    this.goToEntityPage = this.goToEntityPage.bind(this);
    this.showComparison = this.showComparison.bind(this);
    this.getSelectOptions = this.getSelectOptions.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
  }
  goToEntityPage() {
    const { setActivePage } = this.props;
    setActivePage('entity');
  }

  showComparison() {
    const { setComparedEntity } = this.props;
    const { selectedEntity } = this.state;
    if (!selectedEntity) return;
    setComparedEntity(selectedEntity.value);
    this.goToEntityPage();
  }

  onSelectChange(council) {
    this.setState({ selectedEntity: council });
  }

  renderEntities(entities) {
    const { selectedEntity } = this.state;
    return entities.map((entity) => {
      return (
        <div
          key={entity.id}
          role="button"
          onClick={(e) => {
            this.setState({
              selectedEntity: {
                label: entity.name,
                value: entity.id,
              },
            });
          }}
          className={classNames({
            [styles.listItem]: true,
            [styles.listItemActive]: selectedEntity
              ? selectedEntity.value === entity.id
              : false,
          })}
        >
          {entity.name}
        </div>
      );
    });
  }

  renderOtherEntities() {
    const { entities, activeEntity } = this.props;
    const entitiesToCompare = entities.filter((e) => {
      return (
        e.id !== activeEntity.id &&
        // We're allowing all comparisons
        // e.entityCategory === activeEntity.entityCategory &&
        e.compare
      );
    });

    // Group entities by category
    // This is a bit unique to QAO Transport, normally we wouldn't allow comparison across categories
    const entitiesGroupedByCategory = groupByKey(
      entitiesToCompare,
      'listCategory'
    );

    const groupedEntityLists = Object.entries(entitiesGroupedByCategory);

    return (
      <div>
        {groupedEntityLists.map(([key, entities]) => {
          return (
            <div key={key}>
              <h4 className={styles.classificationHeadline}>
                {entityLabelMatcher(key, 'plural')}
              </h4>
              <div className={styles.councilList}>
                {this.renderEntities(entities)}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderEntityList() {
    return this.renderOtherEntities();
  }

  getSelectOptions() {
    const { entities, activeEntity } = this.props;
    return entities
      .filter((e) => e.id !== activeEntity.id && e.compare)
      .map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });
  }

  renderButtonRow() {
    const { selectedEntity } = this.state;
    return (
      <div className={styles.buttonsRow}>
        <button
          type="button"
          className={styles.backLink}
          onClick={this.goToEntityPage}
        >
          <img
            className={styles.backLinkImage}
            src={`${process.env.PUBLIC_URL}/img/close-icon.svg`}
            alt="chevron icon"
            style={{ width: 10, height: 10 }}
          />
          close
        </button>
        <Button disabled={!selectedEntity} whenOnClick={this.showComparison}>
          show comparison
        </Button>
      </div>
    );
  }

  render() {
    const { activeEntity } = this.props;
    return (
      <div className={styles.compareSelectPageWrapper}>
        {this.renderButtonRow()}
        <div className={styles.heading}>{activeEntity.name}</div>
        {/* We're allowing all comparisons */}
        {/* <h3 className={styles.chooseHeadline}>Choose a {entityLabelMatcher(activeEntity.entityCategory, 'singular').toLocaleLowerCase()} to compare</h3> */}
        <h3 className={styles.chooseHeadline}>
          Choose a transport entity to compare
        </h3>
        <div className={styles.formWrapper}>
          <form>{this.renderEntityList()}</form>
        </div>
        {this.renderButtonRow()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActivePage,
  setComparedEntity,
};

const mapStateToProps = (state) => ({
  activeEntity: selectors.getActiveEntity(state),
  entities: selectors.getEntities(state),
});

CompareSelectEntitiesPage.propTypes = {
  entities: PropTypes.arrayOf(PropTypes.object),
  activeEntity: PropTypes.object.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setComparedEntity: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareSelectEntitiesPage);



// WEBPACK FOOTER //
// ./src/pages/compare-select-entities-page/compare-select-entities-page.js